"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackBookingTextClick = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
const enums_1 = require("../enums");
function trackBookingTextClick(label) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventCategory: enums_1.GA4FeatureCategory.DirectBooking,
        eventAction: enums_1.ClickEventType.TEXT_CLICK,
        eventLabel: label,
    });
}
exports.trackBookingTextClick = trackBookingTextClick;
//# sourceMappingURL=trackBookingTextClick.js.map